/**
* DevExpress Analytics (core\internal\dxtTemplate.js)
* Version:  23.2.13
* Build date: Apr 29, 2025
* Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
export function dxtTemplate() {
    const template = 'eyJsaWNlbnNlS2V5IjoiZXdvZ0lDSm1iM0p0WVhRaU9pQXhMQW9nSUNKcGJuUmxjbTVoYkZWellXZGxTV1FpT2lBaVIwaDVTak5RVUVwRGJqVXlZVFJ1WWxOb1lraGhVU0lLZlE9PS5TV1o5SjNoSUxuQkowSmVaNnFXdWRnR3hIRTAxQkRRNitUUjJOQk55QStxcTc1dDRnYWt5VGJXdDhkTUlLNHBnVTM2dWNXOW53S0lIYUFVL1JyR1NqcWFtOGVZbEdYQXBKSGNoV2dMUTFVZU05NndtTGRSemJYbHcxZDNRS2RNUFNDZ0tWZz09In0=';
    return template ? JSON.parse(atob(template)) : null;
}
